import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonBadge } from "@ionic/react";

import { Collapse } from "react-collapse";

import iconDisclosureDown from "../assets/Button_Disclosure_Down_Blue@3x.png";
import iconDisclosureDownDark from "../assets/Button_Disclosure_Down_Blue_Dark@3x.png";
import iconDisclosureUp from "../assets/Button_Disclosure_Up_Blue@3x.png";
import iconDisclosureUpDark from "../assets/Button_Disclosure_Up_Blue_Dark@3x.png";

import "../Shared.css";
import "../../App.css";
import "./AppCard.css";

type Props = {
  title?: string;
  collapsible?: boolean;
  collapsed?: boolean;
  badgeCount?: number;
  collapsedButtonClicked?: () => void;
  headerButtonText?: string;
  headerButtonClicked?: () => void;
  seeAllButtonText?: string;
  seeAllButtonClicked?: () => void;
  removeContentPadding?: boolean;
  darkMode: boolean;
};
type State = {};

class AppCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    let title = null;
    if (this.props.title != null) {
      title = <div className="appCardTitle">{this.props.title}</div>;
    }

    let collapsibleButton = null;
    if (this.props.collapsible) {
      let disclosureIcon = iconDisclosureDown;
      if (this.props.collapsed) {
        if (this.props.darkMode) {
          disclosureIcon = iconDisclosureDownDark;
        } else {
          disclosureIcon = iconDisclosureDown;
        }
      } else {
        if (this.props.darkMode) {
          disclosureIcon = iconDisclosureUpDark;
        } else {
          disclosureIcon = iconDisclosureUp;
        }
      }

      collapsibleButton = (
        <IonButton
          mode="ios"
          aria-label={`${this.props.title} collapse button ${this.props.collapsed ? "open" : "close"}`}
          className="clearButton appCardHeaderButton appCardCollapsibleButton"
          fill="clear"
          onClick={() => {
            if (this.props.collapsedButtonClicked) {
              this.props.collapsedButtonClicked();
            }
          }}
        >
          <img width={12} height={8} src={disclosureIcon} />
        </IonButton>
      );
    }

    let headerButton = null;
    if (this.props.headerButtonText) {
      headerButton = (
        <IonButton
          mode="ios"
          className="clearButton appCardHeaderButton appCardBorderedButton"
          fill="clear"
          onClick={() => {
            if (this.props.headerButtonClicked) {
              this.props.headerButtonClicked();
            }
          }}
        >
          {this.props.headerButtonText}
        </IonButton>
      );
    }

    let seeAllButton = null;
    if (this.props.seeAllButtonText) {
      seeAllButton = (
        <IonButton
          mode="ios"
          className="clearButton appCardHeaderButton appCardBorderedButton"
          fill="clear"
          onClick={() => {
            if (this.props.seeAllButtonClicked) {
              this.props.seeAllButtonClicked();
            }
          }}
        >
          {this.props.seeAllButtonText}
        </IonButton>
      );
    }

    let isCollapsed = false;
    if (this.props.collapsed) {
      isCollapsed = this.props.collapsed;
    }

    let badgeLayout = null;
    if (this.props.badgeCount) {
      badgeLayout = <IonBadge className="appCardBadgeCount">{this.props.badgeCount}</IonBadge>;
    }

    return (
      <div className={`appCardContainer ${this.props.collapsed ? "collapsed" : ""}`}>
        <div className="appCardHeader">
          <div className="appCardHeaderStart">
            {title}
            {badgeLayout}
          </div>
          <div className="appCardHeaderEnd">
            {seeAllButton}
            {collapsibleButton}
            {headerButton}
          </div>
        </div>
        <Collapse isOpened={!isCollapsed}>
          <div className={`appCardContent ${this.props.removeContentPadding ? "noPadding" : ""}`}>
            {this.props.children}
          </div>
        </Collapse>
      </div>
    );
  }
}

export default AppCard;
